import { useQuery } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from './keys';
import type { Partner } from '../types';

/** The partner names some asset carries: the catalog's partner filter and the asset form's suggestions. */
export function usePartners({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.partners,
    queryFn: () => api<{ partners: Partner[] }>('/api/partners'),
    enabled,
  });
}
